import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Shield, AlertCircle, Users, CreditCard, BookOpen, ArrowLeft, Home, CheckCircle, XCircle, MessageCircle } from 'lucide-react';

const TermsOfService = () => {
  const sections = [
    {
      title: 'قبول الشروط',
      icon: CheckCircle,
      content: [
        'باستخدامك لمنصة "منصتي" التعليمية، فإنك توافق على الالتزام بهذه الشروط والأحكام.',
        'إذا لم توافق على هذه الشروط، يرجى عدم استخدام المنصة.',
        'يمكننا تحديث هذه الشروط بشكل دوري، واستمرار استخدامك يعني قبولك للتغييرات.',
        'آخر تحديث: 27 يناير 2026.'
      ]
    },
    {
      title: 'وصف الخدمة',
      icon: BookOpen,
      content: [
        '"منصتي" هي منصة تعليمية متخصصة لطلاب الثانوية العامة في مصر.',
        'نقدم محتوى تعليمي متميز في جميع مواد الثانوية العامة.',
        'الخدمات تشمل: فيديوهات تعليمية، اختبارات، واجبات، متابعة التقدم.',
        'نضمن جودة المحتوى التعليمي وتحديثه المستمر.',
        'المنصة متاحة 24/7 للطلاب المسجلين.'
      ]
    },
    {
      title: 'شروط التسجيل',
      icon: Users,
      content: [
        'يجب أن يكون الطالب في المرحلة الثانوية العامة أو ما يعادلها.',
        'يجب تقديم بيانات صحيحة وحقيقية عند التسجيل.',
        'الحد الأدنى للعمر: 15 سنة.',
        'يجب موافقة ولي الأمر للطلاب أقل من 18 سنة.',
        'كل طالب مسؤول عن حسابه وكلمة المرور الخاصة به.',
        'يحظر مشاركة بيانات الدخول مع الآخرين.'
      ]
    },
    {
      title: 'الاشتراكات والرسوم',
      icon: CreditCard,
      content: [
        'الاشتراكات مدفوعة وتختلف حسب الخدمات المطلوبة.',
        'الأسعار معروضة بوضوح في صفحة الخدمات.',
        'الدفع يتم عبر القنوات الآمنة المعتمدة.',
        'الاشتراكات تلغى تلقائياً عند انتهاء المدة.',
        'لا يوجد استرداد بعد مرور 7 أيام من تاريخ الدفع.',
        'قد نقدم خصومات وعروض خاصة من وقت لآخر.'
      ]
    },
    {
      title: 'حقوق ومسؤوليات الطالب',
      icon: Shield,
      content: [
        'الحقوق:',
        'الوصول لجميع المحتوى التعليمي المدفوع.',
        'الحصول على شهادات إتمام للكورسات.',
        'الدعم الفني طوال فترة الاشتراك.',
        'المسؤوليات:',
        'استخدام المنصة للأغراض التعليمية فقط.',
        'احترام المدرسين والطلاب الآخرين.',
        'عدم محاولة اختراق أو إتلاف المنصة.',
        'الالتزام بالقوانين المصرية المعمول بها.'
      ]
    },
    {
      title: 'المحتوى التعليمي',
      icon: BookOpen,
      content: [
        'جميع المحتويات محمية بحقوق الطبع والنشر.',
        'يحظر نسخ أو توزيع المحتوى بدون إذن كتابي.',
        'المحتوى مخصص للاستخدام الشخصي للطالب المسجل فقط.',
        'نحن نملك حقوق المحتوى أو نملك ترخيصاً لاستخدامه.',
        'قد نستخدم محتوى من جهات خارجية مرخصة.',
        'يحظر استخدام المحتوى لأغراض تجارية.'
      ]
    },
    {
      title: 'الخصوصية والبيانات',
      icon: Shield,
      content: [
        'نحترم خصوصية بياناتك ونحميها بشدة.',
        'نجمع البيانات الضرورية فقط لتقديم الخدمة.',
        'لا نشارك بياناتك مع أطراف ثالثة بدون موافقتك.',
        'نلتزم بقانون حماية البيانات المصري.',
        'يمكنك الاطلاع على سياسة الخصوصية للمزيد من التفاصيل.',
        'بيانات الطلاب القصر تحظى بحماية خاصة.'
      ]
    },
    {
      title: 'السلوك المقبول',
      icon: Users,
      content: [
        'يحظر:',
        'التنمر أو الإساءة للآخرين.',
        'نشر محتوى غير لائق أو مخالف.',
        'الغش في الاختبارات أو الواجبات.',
        'محاولة خداع النظام أو استغلال الثغرات.',
        'الإعلان عن خدمات منافسة.',
        'الالتزام بالسلوك التعليمي السليم.'
      ]
    },
    {
      title: 'الملكية الفكرية',
      icon: FileText,
      content: [
        'اسم "منصتي" وشعارها محميان كعلامات تجارية.',
        'جميع الحقوق محفوظة للمنصة ومؤسسيها.',
        'المحتوى التعليمي محمي بحقوق الطبع والنشر.',
        'التصاميم والواجهات البرمجية ملك للمنصة.',
        'يحظر تقليد أو نسخ أي جزء من المنصة.',
        'المخالفات تعرض المسؤول للعقوبات القانونية.'
      ]
    },
    {
      title: 'إنهاء الخدمة',
      icon: XCircle,
      content: [
        'يمكنك إلغاء اشتراكك في أي وقت.',
        'نحن نحتفظ بحق إلغاء حسابك في الحالات التالية:',
        'انتهاك هذه الشروط والأحكام.',
        'استخدام المنصة لأغراض غير تعليمية.',
        'الإضرار بسمعة المنصة أو المستخدمين الآخرين.',
        'عدم الدفع المستحق للخدمات.',
        'انتهاك القوانين المصرية.',
        'في حالة الإلغاء، لا يتم استرداد المبالغ المدفوعة.'
      ]
    },
    {
      title: 'تحديد المسؤولية',
      icon: AlertCircle,
      content: [
        'المنصة تقدم المحتوى التعليمي "كما هو" بدون أي ضمانات.',
        'لسنا مسؤولين عن نتائج الطلاب الأكاديمية.',
        'نحن لا نضمن الحصول على درجات معينة في الامتحانات.',
        'قد تحدث انقطاعات فنية للصيانة أو التحديث.',
        'نسعى لتقديم خدمة موثوقة ولكن لا نضمن التشغيل 100%.',
        'المسؤولية القصوى للنجاح تعود للطالب نفسه.'
      ]
    },
    {
      title: 'حل النزاعات',
      icon: Shield,
      content: [
        'في حالة وجود نزاع، نسعى لحله ودياً أولاً.',
        'يمكن التواصل مع خدمة العملاء لحل المشاكل.',
        'إذا لم يتم حل النزاع ودياً، يتم اللجوء للقانون المصري.',
        'المحاكم المصرية هي المختصة بالنظر في النزاعات.',
        'نحن نلتزم بالقرارات القضائية النهائية.',
        'نفضل دائماً الحلول الودية التي تحافظ على العلاقة.'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50/50">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <div className="w-20 h-20 bg-white/20 rounded-3xl flex items-center justify-center mx-auto mb-6 backdrop-blur-sm">
              <FileText size={40} />
            </div>
            <h1 className="text-4xl font-black mb-4">الشروط والأحكام</h1>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              شروط استخدام منصة "منصتي" التعليمية لطلاب الثانوية العامة
            </p>
            <Link
              to="/help"
              className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-2xl hover:bg-white/30 transition-all"
            >
              <ArrowLeft size={20} />
              العودة لمركز المساعدة
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Important Notice */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-6 mb-8">
          <div className="flex items-center gap-3">
            <AlertCircle className="text-yellow-600" size={24} />
            <div>
              <h3 className="font-black text-yellow-900">مهم جداً</h3>
              <p className="text-yellow-700">يرجى قراءة هذه الشروط بعناية قبل استخدام المنصة. استخدامك للمنصة يعني قبولك الكامل لهذه الشروط.</p>
            </div>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-8">
          {sections.map((section, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="p-6 border-b border-gray-100">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center">
                    <section.icon size={24} />
                  </div>
                  <h2 className="text-2xl font-black text-gray-900">{section.title}</h2>
                </div>
              </div>
              <div className="p-6">
                <ul className="space-y-3">
                  {section.content.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 leading-relaxed">{item}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Information */}
        <div className="mt-12 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-8">
          <h2 className="text-2xl font-black text-gray-900 mb-6 text-center">لديك استفسارات حول الشروط؟</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl p-6">
              <h3 className="font-black text-gray-900 mb-3">تواصل معنا</h3>
              <p className="text-gray-600 mb-4">فريق الدعم القانوني متاح للإجابة على استفساراتك</p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-black"
              >
                تواصل معنا
                <ArrowLeft size={16} className="rotate-180" />
              </Link>
            </div>
            <div className="bg-white rounded-2xl p-6">
              <h3 className="font-black text-gray-900 mb-3">البريد الإلكتروني</h3>
              <p className="text-gray-600 mb-4">يمكنك مراسلتنا مباشرة على:</p>
              <a 
                href="mailto:legal@manasti.com"
                className="text-blue-600 hover:text-blue-700 font-black"
              >
                legal@manasti.com
              </a>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          <Link
            to="/privacy"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 px-6 py-3 rounded-2xl hover:bg-gray-50 transition-all"
          >
            <Shield size={20} />
            سياسة الخصوصية
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 px-6 py-3 rounded-2xl hover:bg-gray-50 transition-all"
          >
            <MessageCircle size={20} />
            تواصل معنا
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 px-6 py-3 rounded-2xl hover:bg-gray-50 transition-all"
          >
            <Home size={20} />
            الصفحة الرئيسية
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
